export const isAdmin = (profile) => {
  if (profile?.role === 'admin') return true;

  return false;
};
